import React from "react";
import { Hammer, Ruler, Home, ShieldCheck, Users, MessageSquareText, Clock, Award } from "lucide-react";

const ITEMS = [
  { icon: Home, title: "Full-Service GC", body: "Roofing, remodeling, repairs, and maintenance under one roof." },
  { icon: MessageSquareText, title: "Clear Communication", body: "You know what is happening, when, and what it costs." },
  { icon: ShieldCheck, title: "Practical Pricing", body: "Honest estimates and options at multiple price levels." },
  { icon: Hammer, title: "Quality-Focused Workmanship", body: "Long-term relationships are built on work that lasts." },
  { icon: Users, title: "Trusted Subcontractor Network", body: "Specialty trades coordinated through reliable partners." },
  { icon: Clock, title: "One Point of Contact", body: "Stop juggling five contractors for one home." },
  { icon: Ruler, title: "Local to Central Texas", body: "Austin-area focus with familiarity for our climate." },
  { icon: Award, title: "Long-Term Relationships", body: "Built for clients who want a contractor for years, not one job." },
];

export default function WhyBlackRidge() {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="why-grid">
      {ITEMS.map((it) => {
        const Icon = it.icon;
        return (
          <div key={it.title} className="p-5 bg-white border border-gray-200 rounded">
            <div className="w-10 h-10 rounded bg-br-paper flex items-center justify-center mb-3">
              <Icon size={18} className="text-br-bronze" />
            </div>
            <h4 className="font-display tracking-wider uppercase text-sm mb-1">{it.title}</h4>
            <p className="text-xs text-gray-600 leading-relaxed">{it.body}</p>
          </div>
        );
      })}
    </div>
  );
}
